import React from 'react';
import { RouteComponentProps, useParams } from 'react-router-dom';
import DocumentComponent from './document.component';
import { useSelector } from 'react-redux';
import { AppState } from '../../core/store';
import { NewVM } from '../../core/models/news.model';
type Props = RouteComponentProps;

const DocumentContainer: React.FC<Props> = () => {
  const { name }: any = useParams();
  const { documents } = useSelector((state: AppState) => state.common);
  

  const getDocumentUrl = () => {
    return documents.find((item) => item?.feature === name);
  };
  return <DocumentComponent newsDetail={getDocumentUrl() || new NewVM()} />;
};

export default DocumentContainer;
